export default {
  items: (state) => {
    return state.pages.reduce((acc, page) => {
      return [...acc, ...page.data];
    }, []);
  },
};
